import React from 'react'
import './hero.scss'

const Hero = props => {
  return (
    <div>
      <div>
        <div>
          <h2 className="light">
            Our thoughts, perspectives, and musings on{' '}
            {props.tag || 'Technology'}
          </h2>
          <hr />
          <p>
            We share knowledge, ideas and ambitions openly, constantly improving
            and crtiquing our ideas in the larger community.
          </p>
        </div>
      </div>
      {props.scroll}
    </div>
  )
}

export default Hero
